"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lmsAdmin = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Matrix_1 = require("../../../TdWebtoolkitControls/controls/Matrix/Matrix");
require("../../../TdWebtoolkitControls/javascript/Utilities");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const r_css = require("./lmsAdmin.tmpl.less");
const m = require("../SynView");
class lmsAdmin extends m.SynView {
    //#endregion MEMBER VARIABLES
    //#endregion MEMBER VARIABLES
    //#region CONTRUCTORS
    constructor() {
        super();
    }
    //#endregion CONTRUCTORS
    //#region MEMBER METHODS
    //#region Inherited from SynView
    // Initialization of member variables
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-th";
    }
    renderContents() {
        let that = this;
        that.m_$description = that.m_$container.find("div.description")
            .css("height", lmsAdmin.DescriptionPaneHeight.toString() + "px")
            .html(Utilities_1.synUtil.Strings.getValue("lmsadmin.infotext"));
        that.initMatrixControl();
    }
    resizeControls() {
        let that = this;
        if (that.m_$matrix) {
            const innerWidth = that.m_$container.innerWidth() || 0;
            const innerHeight = that.m_$container.innerHeight() || 0;
            that.m_$matrix.synMatrix("resize", innerWidth, innerHeight - lmsAdmin.DescriptionPaneHeight);
        }
    }
    activate() {
        super.activate();
        this.logFullLicense();
    }
    forceRefresh(modifications) { }
    //#endregion Inherited from SynView
    //#region Helpers
    //#region Helpers
    initMatrixControl() {
        let that = this;
        that.m_$matrix = that.m_$container.find("div.lmsMatrix");
        let showPropertyMaskForHeaders = Utilities_1.synUtil.Configs.getValue("lmsadmin.showpropertymaskforheaders");
        let rowClickMode;
        let colClickMode;
        if ("Y" === showPropertyMaskForHeaders || "y" === showPropertyMaskForHeaders) {
            rowClickMode = Matrix_1.RowClickMode.Properties;
            colClickMode = Matrix_1.ColumnClickMode.Properties;
        }
        else if (showPropertyMaskForHeaders) {
            rowClickMode = showPropertyMaskForHeaders.toLocaleLowerCase() === "rows" ? Matrix_1.RowClickMode.Properties : Matrix_1.RowClickMode.None;
            colClickMode = showPropertyMaskForHeaders.toLocaleLowerCase() === "columns" ? Matrix_1.ColumnClickMode.Properties : Matrix_1.ColumnClickMode.None;
        }
        else {
            rowClickMode = Matrix_1.RowClickMode.None;
            colClickMode = Matrix_1.ColumnClickMode.None;
        }
        that.m_$matrix
            .on("cellValueChanged", () => {
            let key = "lmsadmin.onetimenotification";
            let notificationText = Utilities_1.synUtil.Strings.getValue(key);
            if (notificationText && notificationText !== key) {
                if (sessionStorage.getItem("lmsadmin.usernotified") == undefined) {
                    sessionStorage.setItem("lmsadmin.usernotified", "true");
                    Utilities_1.synUtil.Notifications.info(notificationText, { forceCenter: true });
                }
            }
        })
            .on("initSuccess", () => {
            that.resizeControls();
        })
            .synMatrix({
            matrixId: "lms",
            width: that.m_$matrix.parent().innerWidth(),
            height: that.m_$matrix.parent().innerHeight(),
            hoverHighlightingMode: Matrix_1.HighlightingMode.Full,
            rowClickMode,
            colClickMode
        });
    }
}
exports.lmsAdmin = lmsAdmin;
lmsAdmin.DescriptionPaneHeight = 35;
